import { render } from "./VirtualLink.vue?vue&type=template&id=4f228ac2&ts=true"
import script from "./VirtualLink.vue?vue&type=script&lang=ts"
export * from "./VirtualLink.vue?vue&type=script&lang=ts"

import "./VirtualLink.vue?vue&type=style&index=0&id=4f228ac2&lang=scss"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__